module.exports = __webpack_public_path__ + "static/media/arizona.baa352d6.png";